<template>
  <HeaderForm :left-span="24">
    <template v-slot:prepend>
      <el-form
        ref="form"
        :inline="true"
        :model="value"
      >
        <el-form-item prop="taskType">
          <el-select
            v-model="value.taskType"
            clearable
            placeholder="请选择任务"
          >
            <el-option
              label="人员导入"
              value="PERSON_IMPORT"
            />
            <el-option
              label="人员导出"
              value="PERSON_EXPORT"
            />
            <el-option
              label="识别记录导出"
              value="VERIFY_PERSON_RECORD_EXPORT"
            />
            <el-option
              label="人证记录导出"
              value="VERIFY_CERT_RECORD_EXPORT"
            />
            <el-option
              label="进出记录导出"
              value="VERIFY_OUT_IN_RECORD_EXPORT"
            />
            <el-option
              label="详细记录导出"
              value="VERIFY_DETAIL_RECORD_EXPORT"
            />
            <el-option
              label="陌生人记录导出"
              value="VERIFY_STRANGER_RECORD_EXPORT"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="fileName">
          <el-input
            v-model="value.fileName"
            clearable
            placeholder="请输入文件名称"
          />
        </el-form-item>
        <el-form-item prop="operateType">
          <el-select
            v-model="value.operateType"
            clearable
            placeholder="请选择任务类型"
          >
            <el-option
              label="全部"
              :value="null"
            />
            <el-option
              label="导入"
              value="IMPORT"
            />
            <el-option
              label="导出"
              value="EXPORT"
            />
            <el-option
              label="政企协议"
              value="ZQXY"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="taskStatus">
          <el-select
            v-model="value.taskStatus"
            clearable
            placeholder="请选择任务状态"
          >
            <el-option
              label="全部"
              :value="null"
            />
            <el-option
              v-for="item in taskStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          class="customDate"
          prop="time"
        >
          <el-date-picker
            v-model="value.time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onSearch"
          >查询</el-button>
          <el-button
            plain
            @click="resetForm"
          >重置</el-button>
        </el-form-item>
      </el-form>
    </template>
  </HeaderForm>
</template>

<script>
import { taskStatusList } from '../../config'
export default {
  props: {
    value: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      taskStatusList
    }
  },
  methods: {
    onSearch() {
      this.value.pageNumber = 1
      this.$emit('onSearch')
    },
    addNewData() {
      this.$emit('addNewData')
    },
    batchDelete() {
      this.$emit('batchDelete')
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.onSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content{
    width: 160px;
}
::v-deep .customDate .el-form-item__content{
    width: 250px;
}
::v-deep .customDate .el-date-editor{
    width: 250px;
}
</style>
